type RGB = {
    r: number;
    g: number;
    b: number;
};

function generateGradient(rgb: RGB): string[] {
    const { r, g, b } = rgb;
    let gradientColors = [
        `rgba(${r}, ${g}, ${b}, 0.9)`,
        `rgba(${r}, ${g}, ${b}, 0.6)`,
        `rgba(${r}, ${g}, ${b}, 0.3)`,
        `rgba(${r}, ${g}, ${b}, 0.1)`,
    ];

    return gradientColors;
}

function hexToRgb(hex: string): [number, number, number] {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
        ? [
              parseInt(result[1], 16),
              parseInt(result[2], 16),
              parseInt(result[3], 16),
          ]
        : [0, 0, 0];
}

export function generateGradientFromHex(hex: string): string {
    const rgb = hexToRgb(hex);

    const gradients = generateGradient({ r: rgb[0], g: rgb[1], b: rgb[2] });
    // in this format
    return `radial-gradient(85.24% 49.97% at 50.03% 100.00%, ${gradients[0]} 6.42%, ${gradients[1]} 38.29%, ${gradients[2]} 62.96%, ${gradients[3]} 82.40%, rgba(255, 200, 185, 0.00) 93.68%), radial-gradient(126.87% 54.66% at 50.03% 136.03%, rgba(0, 0, 0, 0.64) 32.23%, rgba(0, 0, 0, 0.26) 67.54%, rgba(0, 0, 0, 0.06) 83.47%, rgba(0, 0, 0, 0.00) 97.19%), radial-gradient(126.87% 54.66% at 50.03% 136.03%, rgba(255, 255, 255, 0.80) 32.23%, rgba(255, 255, 255, 0.26) 67.54%, rgba(255, 255, 255, 0.00) 92.88%)`;
}

export function getAnnouncement(
    number: string | undefined | number | null,
    name: string | undefined | null
) {
    return `${number || ''} for ${name || ''}`;
}
